import React, { useState, useEffect, useRef } from "react";
import ChatHistory from "../../assets/AI/history.png";
import Send from "../../assets/AI/send.svg";
import Del2 from "../../assets/AI/del2.svg";
import Logout from "../../assets/AI/logoff.svg";
import User from "../../assets/AI/user.png";
import Assistant from "../../assets/AI/assistant.svg";
import Filter from "../../assets/AI/filter.svg";
import History from "../../assets/AI/history.png";
import { BsFillSendFill } from "react-icons/bs";
import { Link } from "react-router-dom";

const Chat = () => {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const endOfMessages = useRef(null);
  const [show, setShow] = useState(true);
  const [loading, setLoading] = useState(false);

  const clearMessages = () => {
    setMessages([]);
  };

  const handleSend = () => {
    if (input.trim() === "") return;

    setMessages([...messages, { text: input, isUser: true }]);
    setLoading(true);
    setInput("");

    fetch("https://fa4d-35-233-181-165.ngrok-free.app/chat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ message: input }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to get a response from the server.");
        }
        setLoading(false);
        return response.json();
      })
      .then((data) => {
        setMessages((prevMessages) => [
          ...prevMessages,
          { text: data.response, isUser: false },
        ]);
      })
      .catch((error) => {
        console.error("Error sending message:", error);
        setLoading(false);
        setMessages((prevMessages) => [
          ...prevMessages,
          { text: "Sorry, an error occurred.", isUser: false },
        ]);
      });
  };

  useEffect(() => {
    endOfMessages.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [messages]);

  const Examples = [
    "Show me some of my Boards.",
    "How many projects have I created?",
  ];

  return (
    <div className="h-[92vh] flex flex-col md:flex-row bg-[#F9FAFB]">
      <aside className="w-full md:w-[30%] bg-[#F3F4F6] p-6">
        <header className="py-3 border-b-2 text-lg md:text-xl font-semibold border-[#9999ff]">
          Recent Activity
        </header>
        <div className="p-4 mt-6 rounded-md h-[40%] md:h-[60%] overflow-y-auto bg-[#fafafa] shadow-sm">
          {show ? (
            <div>
              <p className="text-gray-500">No recent activity</p>
            </div>
          ) : (
            <div className="flex items-center mb-4">
              <p className="text-lg cursor-pointer flex-1">
                This is my chat History
              </p>
              <img
                src={ChatHistory}
                alt="History"
                className="w-6 h-6 cursor-pointer ml-2"
              />
              <img
                src={Del2}
                alt="Delete"
                className="w-6 h-6 cursor-pointer ml-2"
              />
            </div>
          )}
        </div>

        <footer className="mt-24">
          <div className="text-lg font-semibold">
            <div
              onClick={() => setShow(!show)}
              className="flex items-center cursor-pointer hover:text-gray-800"
            >
              <p className={`flex-1 ${show ? "" : "font-bold"}`}>
                {show
                  ? "Show Previous Conversations"
                  : "Hide Previous Conversations"}
              </p>
              <img src={History} alt="History" className="w-6 h-6 ml-2" />
            </div>
            <div className="flex items-center cursor-pointer mt-4 hover:text-[#6e6ef1]">
              <p className="flex-1">Delete Conversations</p>
              <img src={Del2} alt="Delete" className="w-6 h-6 ml-2" />
            </div>
          </div>
          <button
            onClick={clearMessages}
            className="w-full h-12 mt-6 text-white bg-[#9999ff] rounded-md hover:bg-[#60A5FA]"
          >
            + New chat
          </button>
        </footer>
      </aside>

      <main className="w-full md:w-[70%] flex flex-col p-6">
        <div className="flex-1 overflow-y-auto">
          {messages.length > 0 ? (
            <div className="flex flex-col">
              {messages.map((message, index) => (
                <div
                  key={index}
                  className={`flex items-start mb-6 ${
                    message.isUser ? "flex-row-reverse" : ""
                  }`}
                >
                  <img
                    src={message.isUser ? User : Assistant}
                    alt={message.isUser ? "User" : "Assistant"}
                    className="w-10 h-10 rounded-full shadow-md mr-3"
                  />
                  <div
                    className={`p-4 rounded-lg ${
                      message.isUser
                        ? "bg-[#3B82F6] text-white"
                        : "bg-gray-100 text-gray-800"
                    }`}
                  >
                    {message.text}
                  </div>
                </div>
              ))}
              <div ref={endOfMessages} />
              {loading && (
                <div className="animate-pulse p-4 bg-gray-100 shadow-md rounded-lg">
                  <div className="flex items-center">
                    <div className="w-10 h-10 rounded-full bg-gray-200 mr-4"></div>
                    <div className="flex-1 space-y-2">
                      <div className="h-2 bg-gray-200 rounded"></div>
                      <div className="h-2 bg-gray-200 rounded w-3/4"></div>
                      <div className="h-2 bg-gray-200 rounded w-1/2"></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="flex-1 flex flex-col justify-center items-center text-center">
              <div className="text-4xl font-bold text-[#9999ff] mb-10">
                Collab AI
              </div>
              <div className="flex flex-wrap justify-center gap-4">
                {Examples.map((item, index) => (
                  <div
                    key={index}
                    className="p-4 border-2 border-[#3B82F6] rounded-lg cursor-pointer hover:bg-[#E5E7EB] min-w-[300px]"
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="bg-white border-t border-gray-300 p-4">
          <div className="flex items-center">
            {/* <img src={Filter} alt="Filter" className="w-6 h-6 mr-3" />
            <button className="text-white bg-[#3B82F6] rounded-md px-4 py-2 hover:bg-[#60A5FA]">
              Filter
            </button> */}
            <textarea
              className="flex-1 ml-4 p-3 border rounded-lg shadow-md"
              placeholder="Enter your query here."
              value={input}
              onChange={(e) => setInput(e.target.value)}
            ></textarea>
            <span
              onClick={handleSend}
              className="cursor-pointer text-[#9999ff] ml-4 text-3xl"
            >
              <BsFillSendFill />
            </span>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Chat;
